import React, { FC } from "react";
import { BiCog } from "react-icons/bi";
import { FaMoneyCheck } from "react-icons/fa";
import { LuCreditCard } from "react-icons/lu";
import { IconUsers } from "@tabler/icons-react";
import { AnalyticsIcon } from "@/components/icons";
import { FaMoneyCheckDollar } from "react-icons/fa6";
import { SideBarRouteOption, ISidebarProps } from "@/types";

// Wrapper components to handle isActive prop for react-icons
const CogIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(BiCog, props);

const MoneyCheckIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(FaMoneyCheck, props);

const CreditCardIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(LuCreditCard, props);

const MoneyCheckDollarIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(FaMoneyCheckDollar, props);

const UsersIcon: FC<ISidebarProps> = ({ isActive, ...props }) => 
  React.createElement(IconUsers, props);

const licencingApprovalOfficesRoutes: SideBarRouteOption[] = [
  {
    name: "Statistics",
    path: "/approvalofficesaccount",
    icon: AnalyticsIcon,
  },
  {
    name: "Analytics",
    path: "/approvalofficesaccount/analytics",
    icon: AnalyticsIcon,
  },
  {
    name: "Applications",
    path: "/approvalofficesaccount/applications",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "All Applications",
        path: "/approvalofficesaccount/applications/allapplications",
        icon: MoneyCheckIcon,
      },
      {
        name: "On Hold Applications",
        path: "/approvalofficesaccount/applications/onholdapplications",
        icon: MoneyCheckIcon,
      },
      {
        name: "Approved Applications",
        path: "/approvalofficesaccount/applications/approved-applications",
        icon: MoneyCheckIcon,
      },
      {
        name: "Applications Modifications",
        path: "/approvalofficesaccount/applications/applications-modification",
        icon: MoneyCheckIcon,
      },
      {
        name: "Rejected Applications",
        path: "/approvalofficesaccount/applications/rejected-applications",
        icon: MoneyCheckIcon,
      },
    ],
  },
  {
    name: "Council Payments",
    path: "/approvalofficesaccount/council-payments",
    icon: CreditCardIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "All Payments",
        path: "/approvalofficesaccount/council-payments",
        icon: CreditCardIcon,
      },
      {
        name: "Pending Payments",
        path: "/approvalofficesaccount/council-payments/pending",
        icon: CreditCardIcon,
      },
    ],
  },
  {
    name: "Financial Reports",
    path: "/approvalofficesaccount/Rejected Reports",
    icon: MoneyCheckDollarIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "Student Indexing Under Graduate",
        path: "/approvalofficesaccount/test/test",
        icon: MoneyCheckDollarIcon,
      },
      {
        name: "Student Indexing Under A-Level",
        path: "/approvalofficesaccount/test/test",
        icon: MoneyCheckIcon,
      },
    ],
  },
  {
    name: "Settings",
    path: "/approvalofficesaccount/Manually Assign",
    icon: CogIcon,
    hasSubRoutes: true,
    routes: [
      {
        name: "Manual Assign RegNo",
        path: "/approvalofficesaccount/modifications/ManualAssignRegNo",
        icon: CogIcon,
      },
      {
        name: "Assign RegNo",
        path: "/approvalofficesaccount/modifications/assign-regno",
        icon: CogIcon,
      },
      {
        name: "Existing RegNo",
        path: "/approvalofficesaccount/modifications/ManualAssignExistingRegistration",
        icon: CogIcon,
      },
      {
        name: "Registration Tracker",
        path: "/approvalofficesaccount/modifications/registration-tracker",
        icon: CogIcon,
      },
      {
        name: "Manual Assign Index",
        path: "/approvalofficesaccount/modifications/ManualAssignIndexing",
        icon: CogIcon,
      },
      {
        name: "Assign Index",
        path: "/approvalofficesaccount/modifications/assign-index",
        icon: CogIcon,
      },
      {
        name: "Existing Index",
        path: "/approvalofficesaccount/modifications/ManualAssignExistingIndex",
        icon: CogIcon,
      },
      {
        name: "Index Tracker",
        path: "/approvalofficesaccount/modifications/index-tracker",
        icon: CogIcon,
      },
      {
        name: "User Merge",
        path: "/approvalofficesaccount/system-settings/user-merge",
        icon: UsersIcon,
      },
    ],
  },
];

export default licencingApprovalOfficesRoutes;